<template>
<div>
    <linkbutton toplabel="Update Payment Plan" @click="Start()"/>
    <!-- <pencilbutton @click="Start()"/> -->
    <!-- MODAL -->
      <actionmodal ref="mymodal"> 
        <template v-slot:body>
            <form id="updatepayplanform" ref="updatepayplanform" @submit.prevent>
                <label class="titlelabel">Update Payment Plan</label>
                
                <!-- type -->
                <div class="entry">
                    <div class="entryTextDiv">
                        <label class="entryLabel" for="plantypeselect">Plan Type</label>
                    </div>
                    <select name="" id="plantypeselect" class='entrySelect' v-model="paymentPlan.AccountPaymentPlanTypeID"  v-if='PaymentPlanTypeList.length>0' @change="selectPlanType">
                        <option v-for="pt in PaymentPlanTypeList" :key="pt.AccountPaymentPlantypeID" :value="pt.AccountPaymentPlantypeID" >
                            {{pt.Name}}
                        </option>
                    </select>
                </div>
                
                <formentry inputid="startdate"  inputtype="date" label="Start Date" :isrequired='trueParam' v-model="paymentPlan.StartDate" />
                <formentry inputid="amount"  label="Amount" :isrequired='trueParam' v-model="paymentPlan.Amount"  />
                <formentry inputid="xdays"  label="Notify X Days Before Due" :isrequired='trueParam' v-model="paymentPlan.NotifyXDaysBeforeDue"/>
                
     
                <div class="entry">
                    <div class="entryTextDiv">
                        <label for="notifystudentcheck" class="entryLabel" >Notify Student By Email</label>
                    </div>
                    <input id="notifystudentcheck" class="entryCheckbox" type="checkbox" v-model="paymentPlan.NotifyStudentByEmail" >
                </div>
                <div class="entry">
                    <div class="entryTextDiv">
                        <label for="notifystudentsmscheck" class="entryLabel" >Notify Student By Text</label>
                    </div>
                    <input id="notifystudentsmscheck" class="entryCheckbox" type="checkbox" v-model="paymentPlan.NotifyStudentBySMS" >
                </div>


                <smallbutton  @click="generateitems()" toplabel="Generate Items" :disabled="anyPaid"/>

                <div class="vertFlexCenter">
                    <p class="subtitlelabel" >Payments</p>
                    <p class="subtitlelabel" >Total: ${{ paymentTotal }}</p>
                    <div class="paymentitemrow">
                        <label  class="pmtlabel bold">PAID</label>
                        <label for="amount"  class="pmtlabel bold">Payment Due Amount</label>
                        <label for="date" class="pmtlabel bold">Payment Due Date</label>
                        <label  class="pmtlabel bold">Payment Amount</label>
                        <label  class="pmtlabel bold">Payment Date</label>
                        <label></label>
                    </div>
                    <div v-for="ppi in paymentPlan.PaymentPlanItemList" :key="ppi.AccountPaymentPlanItemID" :value="ppi.AccountPaymentPlanItemID" class="paymentitemrow" v-if="!ppi.isRemoved">
                        <label v-if="isPaid(ppi)" class="pmtlabel">PAID</label>
                        <label v-if="!isPaid(ppi)" class="pmtlabel"></label>

                        <input id="amount" ref="inputs" type="money" v-model="ppi.PaymentDueAmount" class="pmtinput" :disabled="isPaid(ppi)" required ></input>
                        <input id="date" type="date" v-model="ppi.PaymentDueDate" class="pmtinput" :disabled="isPaid(ppi)" required :min="today"></input>
                        <label  class="pmtlabel">{{ ppi.PaymentAmount }}</label>
                        <label  class="pmtlabel">{{ ppi.PaymentDate }}</label>
                        <confirm :showImageButton="trueParam" body="Do you want to remove this payment plan item?"  title="Remove Payment Plan Item" @yes="RemoveItem(ppi)" v-if="!isPaid(ppi)"/>
                    </div>
                    
                </div>
                <smallbutton @click="addpayment()"  toplabel="Add Payment Due"/>

                <br>
                <smallbutton  @click="save()" toplabel="Save" />
                <smallbutton  @click="$refs.mymodal.closeModal()" toplabel="Cancel"/>
                <div v-if="pleaseWait">
                    <label class="pleasewait">Please Wait...</label>
                </div>
                <div>
                    <label class="responsemessage">{{responseMessage}}</label>
                </div>
            </form>
            
        </template>
      </actionmodal>
    </div>
</template>

<script>
import datamethods from '../../datamethods.js'
import format from '../../format.js'
import smallbutton from '../controls/button.vue'
import actionmodal from './actionmodal.vue'
import formentry from '../controls/entry.vue'
import linkbutton from '../controls/linkbutton.vue'
import pencilbutton from '../controls/pencilbutton.vue'
import removebutton from '../controls/removebutton.vue'
import datehelper from '../../datehelper.js'
import confirm from '../actions/confirm.vue'
export default {
    name:'updatepayplan',
    components:{
        smallbutton,
        actionmodal,
        formentry,
        linkbutton,
        pencilbutton,
        removebutton,
        confirm
    },
    props:{
        inpaymentPlan:{
            type:Object,
            required:true
        },
        AccountID:{
            type:Number,
            required:true
        }
        
    },
    mixins:[datamethods,format,datehelper],
    data(){
        return{
            today: new Date().toISOString().split("T")[0], // YYYY-MM-DD
            paymentPlan:{},
            responseMessage:'',
            pleaseWait:false,
            PaymentPlanTypeList:[],
            selectedPlanType:null,
            trueParam:true,
            newPlan:{
                AccountID:0,
                AccountPaymentPlanTypeID:0,
                AccountPaymentPlanID:0,
                Amount:null,
                Name:null,
                NotifyStudentByEmail:true,
                NotifyStudentBySMS:true,
                PaymentPlanItemList:[]

            },
            
        }
    },
    computed:{
        
        anyPaid(){
            var pd = false
            if( this.paymentPlan.PaymentPlanItemList.length>0 ){
                this.paymentPlan.PaymentPlanItemList.forEach(myFunction2)
                function myFunction2(item, index, arr) {
                    let ppi=arr[index]
                    
                    if(ppi.PaymentAmount==ppi.PaymentDueAmount && ppi.PaymentDueAmount!=0){
                        pd=true
                    }
                } 
            }
            
            return pd
        },
        paymentTotal(){
            var total=0
            this.paymentPlan.PaymentPlanItemList.forEach(myFunction2)
            function myFunction2(item, index, arr) {
                let ppi=arr[index]
                if(!ppi.isRemoved){
                    total = total  + Number(ppi.PaymentDueAmount )
                }
                
            } 
            return total.toFixed(2)
        },
        
    },
    methods:{
        refName(ppi){
            return 'ppi' + ppi.AccountPaymentPlanItemID
        },
        async RemoveItem(item){
            item.isRemoved=true
           // this.responseMessage=null
        
            //let req = {
           //     PaymentPlanItem:item,
            //}
            //var response = await this.callAPI(req,'removepaymentplanitem')
            //if(response.Successful){
            //    this.$emit('refresh')
            //}else{
            //   this.responseMessage = response.Message
            //}
            //this.pleaseWait=false;
        },
        selectPlanType(){
            var seltype=this.PaymentPlanTypeList[0]
            var mythis=this
            this.PaymentPlanTypeList.forEach(myFunction2)
            function myFunction2(item, index, arr) {
                let ppt=arr[index]
                if(ppt.AccountPaymentPlantypeID==mythis.paymentPlan.AccountPaymentPlanTypeID){
                    seltype=ppt
                }
            } 
            this.selectedPlanType= seltype
        },
        isPaid(ppi){
            return ppi.PaymentAmount==ppi.PaymentDueAmount && (ppi.PaymentDueAmount!=0 && ppi.PaymentDueAmount!=null)
        },
        
        async gettypes(){
            this.pleaseWait=true
            this.message = ''
            var response = await this.callAPI(null,'paymentplantype')    
            if(response.Successful){
                this.PaymentPlanTypeList=response.PaymentPlanTypeList

                if(this.paymentPlan.AccountPaymentPlanTypeID!=null){
                    this.selectPlanType()
                }
            }else{
                this.message = response.Message
            }
            this.pleaseWait=false
        },
        async Start(){
            this.responseMessage=null
            this.paymentPlan=JSON.parse(JSON.stringify(this.inpaymentPlan)) //make copy. not share reference
            var mythis = this
            
            //if its new, then get a clean one
            if(this.paymentPlan.AccountPaymentPlanID==0){
                this.paymentPlan= JSON.parse(JSON.stringify(this.newPlan))
                this.paymentPlan.StartDate =this.$options.filters.formatDateForInputToday()
                this.paymentPlan.AccountID=this.AccountID
                
            }
            else{
                console.log('amt ' + this.paymentPlan.Amount)
                this.paymentPlan.StartDate =this.$options.filters.formatDateForInput(this.paymentPlan.StartDate);
                if(this.paymentPlan.Amount!=null){this.paymentPlan.Amount =Number(this.paymentPlan.Amount).toFixed(2)}

                this.paymentPlan.PaymentPlanItemList.forEach(myFunction2)
                function myFunction2(item, index, arr) {
                    let ppi=arr[index]
                    if(ppi.PaymentAmount!=null){ppi.PaymentAmount=Number(ppi.PaymentAmount).toFixed(2)}
                    if(ppi.PaymentDueAmount!=null){ppi.PaymentDueAmount=Number(ppi.PaymentDueAmount).toFixed(2)}
                    ppi.PaymentDueDate = mythis.$options.filters.formatDateForInput(ppi.PaymentDueDate);
                    if(ppi.PaymentDueDate.includes('0001-01-01')){ppi.PaymentDueDate=null}

                    ppi.PaymentDate = mythis.$options.filters.formatDateShort(ppi.PaymentDate);
                    if(ppi.PaymentDate.includes('01/01')){ppi.PaymentDate=null}

                    if(ppi.PaymentAmount==0){ppi.PaymentAmount=null}
                } 
            }
            
            this.gettypes()
            this.$refs.mymodal.openModal()

        },
        
        generateitems(){
            if(this.paymentPlan.Amount==null){this.responseMessage="Please enter an amount before Generating Payment Items."; return; }
            this.paymentPlan.PaymentPlanItemList=[]

            console.log('in gen' + this.selectedPlanType.PercentDown + ' ' + this.paymentPlan.Amount)
            var downPayment = Number(this.selectedPlanType.PercentDown) / 100 * Number(this.paymentPlan.Amount)
            downPayment=downPayment.toFixed(2)
            var balance = Number(this.paymentPlan.Amount) - downPayment
            var remainingPaymentCount = Number(this.selectedPlanType.PaymentCount -1)
            var paymentAmount = balance / remainingPaymentCount
            paymentAmount = paymentAmount.toFixed(2)
            var nextDate = new Date(this.paymentPlan.StartDate + ' 12:00:00')
            var daysBetween = Number(this.selectedPlanType.DaysBetweenPayments)

            console.log('gen ' + downPayment + ' ' + balance + ' ' + remainingPaymentCount + ' '  + paymentAmount + ' ' + nextDate + ' ' + daysBetween)

            //down pmt first
            var newpmt={
                AccountPaymentPlanID:0,
                AccountPaymentPlanItemID:0,
                PayementAccountTransactionID:0,
                PaymentAmount:null,
                PaymentDate:null,
                PaymentDueAmount:downPayment,
                PaymentDueDate:this.$options.filters.formatDateForInput(nextDate)
            }
            this.paymentPlan.PaymentPlanItemList.push(newpmt)
            
            var total=downPayment
            for(let i = 1; i<remainingPaymentCount+1; i++){
                var dt = this.AddDate(nextDate, (i * daysBetween ),"d")
                dt = this.$options.filters.formatDateForInput(dt)
                total = Number(total) + Number(paymentAmount)
                console.log('gen ' + i + ' ' +  this.paymentPlan.Amount + ' ' + total)
                //if this is the last one, and the total doesnt equal the plan amt, fix it
                if(i==remainingPaymentCount) {
                    if(total != this.paymentPlan.Amount){
                        console.log('gen ' + this.paymentPlan.Amount + ' ' + total)
                        paymentAmount = Number(paymentAmount) + (Number(this.paymentPlan.Amount) - Number(total))
                        paymentAmount=paymentAmount.toFixed(2)
                    }
                }
                var newpmt={
                    AccountPaymentPlanID:0,
                    AccountPaymentPlanItemID:0,
                    PayementAccountTransactionID:0,
                    PaymentAmount:null,
                    PaymentDate:null,
                    PaymentDueAmount:paymentAmount,
                    PaymentDueDate:dt
                }
                this.paymentPlan.PaymentPlanItemList.push(newpmt)
            }
        },
        addpayment(){
            var newpmt={
                AccountPaymentPlanID:0,
                AccountPaymentPlanItemID:0,
                PayementAccountTransactionID:0,
                PaymentAmount:null,
                PaymentDate:null,
                PaymentDueAmount:null,
                PaymentDueDate:null,
                isRemoved:false
            }
            this.paymentPlan.PaymentPlanItemList.push(newpmt)
           
            //set focus to the new one
            this.$nextTick(()=>{
                const lastInput = this.$refs.inputs[this.$refs.inputs.length - 1];
                if (lastInput) lastInput.focus();
            });
            
        },
        async save(){
            this.responseMessage=null
            if(this.$refs.updatepayplanform.checkValidity()==false){
                this.responseMessage="Please fill in all of the required fields."
                return
            }

            if(Number(this.paymentTotal)!=Number(this.paymentPlan.Amount)){
                this.responseMessage="Please enter payments that add up to the payment plan amount of $" + this.paymentPlan.Amount + ' The current payments add up to $' + this.paymentTotal + '.'
                return
            }

            if(!this.paymentPlan.NotifyStudentByEmail && !this.paymentPlan.NotifyStudentBySMS){
                this.responseMessage="Please select either notification by Email or Text."
                return
            }
            this.pleaseWait=true
            let req = {
                PaymentPlan:this.paymentPlan,
            }
            var response = await this.callAPI(req,'updatepaymentplan')
            if(response.Successful){
                this.$refs.mymodal.closeModal()
                console.log(response)
                this.$emit('refresh')
            }else{
                this.responseMessage = response.Message
            }
            this.pleaseWait=false;
        },
      
    }
}
</script>

<style>
.pmtinput{
    margin:5px;
}
.pmtlabel{
    margin:5px;
}
 .paymentitemrow{
    text-align: left;
    display:grid;
    grid-template-columns:50px 130px 130px 100px 100px 50px;
 }
.entryCheckLabel{
    margin:0px 0px 0px 5px;
    font-size:medium;
    text-align: left;  
    max-width: 420px;
}
.entryCheckLabelbold{
    margin:0px 0px 0px 5px;
    font-size:medium;
    text-align: left;  
    max-width: 420px;
    font-weight:bold;
}
.subtitlelabel{
    font-size:larger;
    font-weight:bold;
    margin:20px;
}
.addbutton{
    width:100px;
    height:30px;
    background-color: var(--button-color);
    color:var(--button-text-color);
    border:none;
}
</style>





























